export default "__VITE_ASSET__CbnjT_Mh__"